if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification') || null;
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let submitBtn = this.querySelector('[type="submit"]');
      if (!submitBtn) {
        submitBtn = this.querySelector('button[type="submit"]');
      }
    
      if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      if (this.cartNotification) this.cartNotification.setActiveElement(document.activeElement);
      submitBtn.setAttribute('aria-disabled', true);
      submitBtn.classList.add('loading');
      submitBtn.setAttribute('aria-disabled', true);
      submitBtn.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cartNotification) formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = submitBtn.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            submitBtn.setAttribute('aria-disabled', true);
            submitBtn.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          if (this.cartNotification) {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cartNotification.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cartNotification.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.error = true;
        })
        .finally(() => {
          submitBtn.classList.remove('loading');
          if (!this.error) submitBtn.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
